<ms-my-bets-betslip-expand [betslipId]="betslip.betslipRealId" [myBetsListContext]="myBetsListContext" [bets]="betslip.bets">
    <ms-my-bets-betslip-card-title-options
        badges
        [betslip]="betslip"
        [myBetsListContext]="myBetsListContext"
        [isBetSlipBadgeVisible]="true"></ms-my-bets-betslip-card-title-options>
    <ng-container collapsed_view>
        <ms-my-bets-multi-bet-card-collapsed [bets]="betslip.bets" [betResults]="betResults" [isLive]="isLive"></ms-my-bets-multi-bet-card-collapsed>
    </ng-container>
    <ng-container expanded_view>
        @if (isCashoutMessageVisible) {
            <ms-edit-bet-cashout-message></ms-edit-bet-cashout-message>
            <div class="mybets-card-divider"></div>
        }
        @for (bet of betslip.bets; track bet) {
            <ms-my-bets-multi-bet-card-detail
                [bet]="bet"
                [betslip]="betslip"
                [state]="getExpandedCardState(bet)"
                [myBetsListContext]="myBetsListContext"
                [enableFlash]="enableFlash"
                [hideOdds]="betslip.isTeaserBet"
                [ngClass]="{ 'multi-bet-combo-type': isIndicatorConnectorEnabledForMultiBets }"
                [cashedOut]="betslip.isCachedOut" />
        }

        @if (hasBetProtection) {
            <ms-my-bets-bet-protector [betslip]="betslip" />
        }
    </ng-container>

    <ng-container mybets-expand-betslip-headsection>
        @if (myBetsUtilService.isBetCardRedesigned()) {
            <ms-my-bets-bet-card-title
                [betslip]="betslip"
                [myBetsListContext]="myBetsListContext"
                [showEditButton]="true"
                [showOutcomeBadge]="true"
                [shouldApplyPaddings]="true">
                <ng-container title>
                    @if (betbuilderPicks.length) {
                        <div class="sgp-container">
                            @if (myBetsConfig.showBetTypeAsBadge) {
                                <ms-sgp-plus-badge size="large" />
                            } @else {
                                <span class="mybets-betslip-multi-header_bet-type bold highlight">{{
                                    sitecoreMyBets.myBets.BetbuilderComboHeader
                                }}</span>
                            }
                            <span class="mybets-betslip-multi-header_pick-count combo-bet"> {{ betbuilderLegs }}</span>
                        </div>
                    } @else {
                        @if (betslip.isTeaserBet) {
                            <span class="mybets-betslip-multi-header_teaser-amount">{{ betslip.teasedAmount }}-{{ sitecoreMyBets.myBets.PT }}</span>
                        }
                        <span class="mybets-betslip-multi-header_bet-type bold highlight">{{ cardTitle }}</span>
                        @if (!isSystemBet()) {
                            <span class="mybets-betslip-multi-header_pick-count"> {{ betslip.bets.length }} {{ sitecoreMyBets.myBets.Legs }}</span>
                        }
                    }
                    @if (myBetsListContext.isPrintView) {
                        <span class="mybets-betslip-multi-header_print-betslip-id"
                            >{{ sitecoreMyBets.myBets.BetSlipNr }}: {{ betslip.betslipId }}</span
                        >
                    }
                </ng-container>
                <ng-container sub_title>
                    @if (betbuilderPicks.length) {
                        <div class="mybets-betslip-multi-collapsed-view_options clearfix">
                            @for (bet of betslip.bets; track bet) {
                                @if (!bet.betBuilderInfo) {
                                    <span class="mybets-betslip-multi-collapsed-view_option-name">{{ bet.optionName }}</span>
                                } @else {
                                    @for (leg of bet.betBuilderInfo.legs; track leg) {
                                        <span class="mybets-betslip-multi-collapsed-view_option-name">{{ leg.name }}</span>
                                    }
                                }
                            }
                        </div>
                    } @else {
                        <div class="mybets-betslip-multi-collapsed-view_options clearfix">
                            @for (bet of betslip.bets; track bet) {
                                <span class="mybets-betslip-multi-collapsed-view_option-name">{{ bet.optionName }}</span>
                            }
                        </div>
                    }
                </ng-container>
            </ms-my-bets-bet-card-title>
        }
    </ng-container>
    <ng-container title>
        @if (isEpcotEnabled) {
            @if (betbuilderPicks.length) {
                <span class="mybets-betslip-multi-header_bet-type bold highlight">{{ sitecoreMyBets.myBets.BetbuilderComboHeader }}</span>
                <span class="mybets-betslip-multi-header_pick-count"> {{ betbuilderLegs }}</span>
            } @else {
                <span class="mybets-betslip-multi-header_bet-type bold highlight">{{ cardTitle }}</span>
                <span class="mybets-betslip-multi-header_pick-count"> {{ betslip.bets.length }} {{ sitecoreMyBets.myBets.picks }}</span>
                @if (betslip.isTeaserBet) {
                    <span class="mybets-betslip-multi-header_teaser-amount"> {{ betslip.teasedAmount }} {{ sitecoreMyBets.myBets.Points }}</span>
                }
            }
        } @else {
            <span class="mybets-betslip-multi-header_bet-type bold highlight">{{ cardTitle }}</span>
            <span class="mybets-betslip-multi-header_pick-count"> - {{ betslip.bets.length }} {{ sitecoreMyBets.myBets.picks }}</span>
        }

        @if (myBetsListContext.isPrintView) {
            <span class="mybets-betslip-multi-header_print-betslip-id">{{ sitecoreMyBets.myBets.BetSlipNr }}: {{ betslip.betslipId }}</span>
        }
    </ng-container>
</ms-my-bets-betslip-expand>
